<div class="layout-container">
	<app-header (toggleSidebar)="onToggleSidebar()"></app-header>
	<mat-sidenav-container class="sidenav-container">
		<mat-sidenav
			#drawer
			class="sidenav"
			fixedInViewport
			[attr.role]="'navigation'"
			[mode]="'side'"
			[opened]="isSidebarOpen"
		>
			<!-- Global Management Section -->
			<div class="menu-section" *ngIf="isRouteActive('/global-management')">
				<div class="section-header">
					<mat-icon>settings</mat-icon>
					Global Management
				</div>
				<mat-nav-list>
					<a
						mat-list-item
						class="top-item"
						routerLink="/global-management"
						routerLinkActive="active"
						[routerLinkActiveOptions]="{ exact: true }"
					>
						<mat-icon matListItemIcon>dashboard</mat-icon>
						<span matListItemTitle>Dashboard</span>
					</a>
					<a
						mat-list-item
						routerLink="/global-management/admins"
						routerLinkActive="active"
					>
						<mat-icon matListItemIcon>admin_panel_settings</mat-icon>
						<span matListItemTitle>Global Admins</span>
					</a>
					<a
						mat-list-item
						routerLink="/global-management/users"
						routerLinkActive="active"
					>
						<mat-icon matListItemIcon>people</mat-icon>
						<span matListItemTitle>All Users</span>
					</a>
					<a
						mat-list-item
						routerLink="/global-management/feedback"
						routerLinkActive="active"
					>
						<mat-icon matListItemIcon>feedback</mat-icon>
						<span matListItemTitle>Feedback</span>
					</a>
				</mat-nav-list>
			</div>

			<!-- Partners Section -->
			<div class="menu-section" *ngIf="isRouteActive('/partners')">
				<div class="section-header" *ngIf="!(currentPartner$ | async); else partnerHeader">
					<mat-icon>business</mat-icon>
					Partners
				</div>
				<ng-template #partnerHeader>
					<div
						class="section-header context-header"
						*ngIf="currentPartner$ | async as partner"
					>
						<div class="context-logo">
							<img
								[src]="partner.logo_url || DEFAULT_PARTNER_LOGO"
								[alt]="partner.name + ' logo'"
								class="entity-logo"
								(error)="onPartnerLogoError($event)"
							/>
						</div>
						<div class="context-info">
							<span class="context-name">{{ partner.name }}</span>
						</div>
					</div>
				</ng-template>
				<mat-nav-list>
					<a
						mat-list-item
						class="top-item"
						routerLink="/partners"
						routerLinkActive="active"
						[routerLinkActiveOptions]="{ exact: true }"
					>
						<mat-icon matListItemIcon>list</mat-icon>
						<span matListItemTitle>All Partners</span>
					</a>
					<ng-container *ngIf="isPartnerView()">
						<a
							mat-list-item
							[routerLink]="['/partners', getPartnerId(), 'dashboard']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>dashboard</mat-icon>
							<span matListItemTitle>Dashboard</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/partners', getPartnerId(), 'details']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>info</mat-icon>
							<span matListItemTitle>Details</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/partners', getPartnerId(), 'organizations']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>groups</mat-icon>
							<span matListItemTitle>Organizations</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/partners', getPartnerId(), 'users']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>people</mat-icon>
							<span matListItemTitle>Users</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/partners', getPartnerId(), 'imports']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>upload_file</mat-icon>
							<span matListItemTitle>Import Users</span>
						</a>
					</ng-container>
				</mat-nav-list>
			</div>

			<!-- Organizations Section -->
			<div class="menu-section" *ngIf="isRouteActive('/organizations')">
				<div
					class="section-header"
					*ngIf="!(currentOrganization$ | async); else organizationHeader"
				>
					<mat-icon>groups</mat-icon>
					Organizations
				</div>
				<ng-template #organizationHeader>
					<div
						class="section-header context-header"
						*ngIf="currentOrganization$ | async as organization"
					>
						<div class="context-logo">
							<img
								[src]="organization.logo_url || DEFAULT_ORGANIZATION_LOGO"
								[alt]="organization.name + ' logo'"
								class="entity-logo"
								(error)="onOrganizationLogoError($event)"
							/>
						</div>
						<div class="context-info">
							<span class="context-name">{{ organization.name }}</span>
						</div>
					</div>
				</ng-template>
				<mat-nav-list>
					<a
						mat-list-item
						class="top-item"
						routerLink="/organizations"
						routerLinkActive="active"
						[routerLinkActiveOptions]="{ exact: true }"
					>
						<mat-icon matListItemIcon>list</mat-icon>
						<span matListItemTitle>All Organizations</span>
					</a>
					<ng-container *ngIf="isOrganizationView()">
						<a
							mat-list-item
							[routerLink]="['/organizations', getOrganizationId(), 'dashboard']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>dashboard</mat-icon>
							<span matListItemTitle>Dashboard</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/organizations', getOrganizationId(), 'details']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>info</mat-icon>
							<span matListItemTitle>Details</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/organizations', getOrganizationId(), 'admin']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>admin_panel_settings</mat-icon>
							<span matListItemTitle>Admin</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/organizations', getOrganizationId(), 'assessees']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>people</mat-icon>
							<span matListItemTitle>Assessee's</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/organizations', getOrganizationId(), 'cohorts']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>groups</mat-icon>
							<span matListItemTitle>Cohorts</span>
						</a>
						<a
							mat-list-item
							[routerLink]="['/organizations', getOrganizationId(), 'imports']"
							routerLinkActive="active"
						>
							<mat-icon matListItemIcon>upload_file</mat-icon>
							<span matListItemTitle>Import Users</span>
						</a>
					</ng-container>
				</mat-nav-list>
			</div>
		</mat-sidenav>
		<mat-sidenav-content>
			<main class="content">
				<router-outlet></router-outlet>
			</main>
			<app-feedback></app-feedback>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>
